module.exports = __webpack_public_path__ + "img/27.b5e0ecb0.png";